<template>
  <div
    class="d-flex-column justify-start align-start gap-5"
  >
    <h4 class="t-white font-family-1 title-h5 f-w-600">
      {{ $t("new_text.select_camo") }}
    </h4>
    <div class="mobile_camo_picker_container b-radius-12">
      <button
        class="mobile_camo_selector b-radius-6 space-between"
        :class="[isOpen && 'opened']"
        @click.stop="toggleOpen"
        v-click-outside="closeOutside"
      >
        <p class="t-white medium-l font-family-2">{{ selectedCamoCategory }}</p>
        <ChevDown />
        <Transition name="slide-fade-top">
          <div class="camo_list_container b-radius-6" v-if="isOpen">
            <button
              class="camo_option t-white medium-l font-family-2"
              v-for="packOption in packOptions"
              :key="packOption"
              :class="[
                checkoutStore.getCamoCategory === packOption.id && 'selected',
              ]"
              @click="() => selectOption(packOption)"
            >
              {{ packOption.title }}
            </button>
            <button
              class="camo_option t-white medium-l font-family-2"
              v-for="packOption in specialOptions"
              :key="packOption"
              @click="selectSpecial(packOption)"
            >
              {{ $t(packOption.title) }}
            </button>
          </div>
        </Transition>
      </button>
    </div>

    <div class="warning_message d-flex-row justify-start" v-if="warningType">
      <img
        src="/images/icons/warning-icon.webp"
        alt="warning_icon"
        height="30"
        width="30"
      />
      <p class="t-white font-family-2 medium-m" style="line-height: 16px">
        {{ $t(`new_text.${warningType}_warning`) }}
      </p>
    </div>

    <div
      class="warning_message d-flex-row justify-start"
      v-if="checkoutStore?.getCamoSpecials?.id"
    >
      <img
        src="/images/icons/warning-icon.webp"
        alt="warning_icon"
        height="30"
        width="30"
      />
      <p class="t-white font-family-2 medium-m" style="line-height: 16px">
        {{ $t(`${checkoutStore?.getCamoSpecials?.const_title}_warning`) }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { calculateCurrency } from "~/calculate/calculatePrice";
import ChevDown from "~/components/icons/ChevDown.vue";
const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();
const userStore = useUserStore();

const isOpen = ref(false);
const toggleOpen = () => {
  isOpen.value = !isOpen.value;
};
const closeOutside = () => {
  isOpen.value = false;
};

const { t } = useI18n();
const packOptions = computed(() => {
  return (
    gameStore.getGamePack.pack_options?.filter(
      (gp) => !gp.const_title.includes("bundle")
    ) || []
  );
});
const specialOptions = computed(() => {
  const packPrices =
    gameStore.getGamePack?.prices?.filter((p) => p.description === "bundle") ||
    [];
  return packPrices;
});

const selectOption = (option) => {
  checkoutStore.setCamoCategory(option.id);
};

const warningType = computed(() => {
  const option = packOptions.value?.find(
    (op) => op.id === checkoutStore.getCamoCategory
  );
  if (!option) return "";
  if (["gold", "mythic_gold", "gold_tiger"].includes(option?.const_title))
    return "";
  return option?.const_title;
});

const price = (option) => {
  const pp = calculateCurrency(option.price);
  return parseFloat(pp).toFixed(2);
};

const selectSpecial = (option) => {
  const isSelected = checkoutStore.getCamoSpecials?.id === option?.id;

  if (isSelected) {
    // checkoutStore.setCamoSpecials(null);
  } else {
    checkoutStore.setCamoSpecials({
      id: option?.id,
      title: t(option?.title),
      price: price(option),
      timing: option?.timing,
      const_title: option.title,
    });
  }
};

const selectedCamoCategory = computed(() => {
  const category = packOptions.value?.find(
    (pO) => pO.id === checkoutStore.getCamoCategory
  );

  if (category?.const_title) {
    return t(`call-of-duty-boost.type.${category.const_title}`);
  }

  if (checkoutStore.camoSpecials?.id) {
    return t(checkoutStore.camoSpecials?.const_title);
  }
  return "";
});
</script>

<style lang="scss">
.mobile_camo_picker_container {
  width: 100%;
  padding: 12px;
  border: 1px solid var(--stroke-dark);
  .mobile_camo_selector {
    width: 100%;
    padding: 9px 12px;
    border: 1px solid var(--blue);
    background-color: var(--dark-blue);
    position: relative;
    svg {
      transition: all 0.2s ease;
    }
    &.opened {
      svg {
        transform: rotate(180deg);
      }
    }
    .camo_list_container {
      position: absolute;
      border: 1px solid var(--stroke-dark);
      top: 110%;
      left: 0;
      width: 100%;
      height: max-content;
      max-height: 350px;
      padding: 9px 12px;
      z-index: 999;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 6px;
      flex-direction: column;
      background-color: var(--bg-main);
      overflow: auto;
      .camo_option {
        width: 100%;
        background-color: var(--bg-medium);
        padding: 9px 12px;
        border-radius: 9px;
        border: 1px solid transparent;
        &.selected {
          border: 1px solid var(--blue);
          background-color: var(--dark-blue);
        }
      }
    }
  }
}
</style>
